module.exports = __webpack_public_path__ + "static/media/background.3b639d34.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/ContactsPage/background.png
// module id = 1225
// module chunks = 1